
/* Generated apis ---------------------- */
import { to } from 'react-lib/utils'
import BaseService from  'react-lib/apis/services/BaseService'
import config from '../../config/config'
import DrugOrderItemEditStdTimeSerializer from '../types/DrugOrderItemEditStdTimeSerializer_apps_TPD'


const HOST = `${config.API_HOST}`
/* ['generics.UpdateAPIView'] */
/* params:  */
/* data:  */
const DrugOrderItemEditStdTime : 
{
  update:   ({pk, params, data, apiToken, extra}:
             { pk: any, 
                params?: any,
                data?: Partial<DrugOrderItemEditStdTimeSerializer>,
                apiToken?: any,
                extra?: any,
            }) => any,
  patch:    ({pk, params, data, apiToken, extra}:
             { pk: any, 
                params?: any,
                data?: Partial<DrugOrderItemEditStdTimeSerializer>,
                apiToken?: any,
                extra?: any,
            }) => any,
} = 
{
  update: async ({pk, params, data, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken)
      base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
    if (extra?.division)
      base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device)
      base.client.defaults.headers.common["device"] = extra.device;
    const result = await to(base.client.put(`${HOST}/apis/TPD/drug-order-item/${pk}/edit/std-time-manual/`,
      data,
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },

  patch: async ({pk, params, data, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken)
      base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
    if (extra?.division)
      base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device)
      base.client.defaults.headers.common["device"] = extra.device;
    const result = await to(base.client.patch(`${HOST}/apis/TPD/drug-order-item/${pk}/edit/std-time-manual/`,
      data,
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },
}

export default DrugOrderItemEditStdTime

